export const URL_ENTRY_SEPARATOR = "--";
export const URL_KEY_VAL_SEPARATOR = "__";
export const URL_PARAM_PREFIXES = {
    form: "fp_",
    lookup: "lkp_",
    exclude: "exc_",
    column: "c_",
};
export const URL_SELECTION_KEY = "selection";
